import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Blobs } from 'my-lib-sanfelici/my-lib-sanfelici';


@Component({
  selector: 'app-blob-list-view',
  templateUrl: './blob-list-view.component.html',
  styleUrls: ['./blob-list-view.component.scss']
})
export class BlobListViewComponent implements OnInit {
@Input() blobs:Observable<Blobs[]>;
  constructor() { }
  onClick(item:Blobs){
    
  }
  onDelete(key) {
    
  
  }
  ngOnInit() {
  }

}
